import src from "IMAGE";
export default { src, width: 119, height: 31, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AF0AEEVfABBKmAAbjagAHZarAB6XsAAepbEAH6d4ABVwAHoAFU5qABJNvgAhpdUAJazYACWx3gAmwd8AJ8GYABqGap0UkDcxiOoAAAAASUVORK5CYII="};
